import StandardCard from './StandardCard';

export default StandardCard;
export * from './StandardCard';
